if (!document.getElementById("employer-edit-review-frm")) return;

const reviewCriteria = [
    'overall-experience',
    'salary-and-benefits',
    'learning-and-development',
    'workload-rating',
    'new-graduate-friendy',
    'leadership-and-management',
    'mentoring-opportunities',
    'overall-culture',
    'operational-effeciency',
    'recommend-to-others',
];

const ratingDiv = document.querySelectorAll(".rating");
const editEmployerReview = document.querySelectorAll(".edit-review-modal");
const employerReviewForm = document.getElementById("employer-edit-review-frm");
const employerReviewSubmit = document.getElementById("review-employer-btn");

const formElements = employerReviewForm.elements;
const ratingLabels = employerReviewForm.querySelectorAll(".rating label");

const loader = document.createElement('span');
loader.className = 'loader btn-loading submit';
loader.innerHTML  =
'<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.824 0 0.553781 3.954 0.0507812 9H2.06836C2.56336 5.06 5.928 2 10 2C14.072 2 17.4366 5.06 17.9316 9H19.9492C19.4452 3.954 15.176 0 10 0ZM0.0507812 11C0.250781 13.008 1.05458 14.8374 2.26758 16.3184L3.6875 14.8984C2.8295 13.7924 2.25136 12.457 2.06836 11H0.0507812ZM16.2715 14.9297C15.8575 15.4547 15.3855 15.9328 14.8555 16.3398L15.8672 18.0742C16.6802 17.4832 17.399 16.7698 18.002 15.9668L16.2715 14.9297ZM5.10352 16.3105L3.68164 17.7324C4.98764 18.8014 6.56592 19.5496 8.29492 19.8516L8.4375 17.8398C7.2005 17.5918 6.06452 17.0595 5.10352 16.3105ZM13.1309 17.3516C12.2949 17.7086 11.3846 17.9285 10.4316 17.9805L10.2891 19.9863C11.6611 19.9473 12.9606 19.621 14.1406 19.082L13.1309 17.3516Z" fill="#fff" /></svg>';


ratingDiv.forEach(ratingGroup => {
    ratingGroup.addEventListener('click', function(event) {
        if (event.target.classList.contains('icon-star')) {
            const input = ratingGroup.querySelector(`#${event.target.getAttribute('for')}`);
            const value = parseInt(input.value);

            // Remove all 'checked' classes first
            ratingGroup.querySelectorAll('.icon-star').forEach((label, index) => {
                if ((5 - index) <= value) {
                    label.classList.add('checked');
                } else {
                    label.classList.remove('checked');
                }
            });
        }
    });
});

editEmployerReview.forEach(button => {
    button.addEventListener("click", function(event) {
        const employer_id = this.getAttribute("data-employerid");
        const employerId = document.getElementById('employer-id');
        employerId.value = employer_id;

        const employerName = this.getAttribute("data-fullname");
        document.querySelector(".review-employee-modal .custom-modal-header h3 span").textContent = employerName;

        reviewCriteria.forEach((criterion) => {
            const dataKey = 'data-' + criterion.replace(/-/g, '_');
            const rating = parseInt(this.getAttribute(dataKey)) || 0;

            for (let i = 1; i <= 5; i++) {
                const starLabel = document.querySelector(`label[for="${criterion}${i}"]`);
                if (starLabel) {
                    if (i <= rating) {
                        starLabel.classList.add('checked');
                    } else {
                        starLabel.classList.remove('checked');
                    }
                }
            }
        });
        
    });
});

employerReviewSubmit.addEventListener("click", function() {
    employerReviewForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
});

// Form submission handler
employerReviewForm.addEventListener("submit", function(event) {
    event.preventDefault();

    const formData = new FormData(employerReviewForm);
    formData.append('action', 'employee_review_employer');
    formData.append('nonce', ajax_callback_data.ajax_nonce);
    employerReviewDisable();

    fetch(ajax_callback_data.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(res => res.json())
    .then(data => {
        // console.log(data)
        if (data.success) {
            console.log('Review saved');
        } else {
        }
       employerReviewEnable();
    })
    .catch((error) => {
        console.log('Something error')
    })
    .finally(() => {
        employerReviewEnable();
    });
});

function employerReviewEnable() {
    for (let i = 0; i < formElements.length; i++) {
        formElements[i].disabled = false;
    }
    ratingLabels.forEach(label => {
        label.style.pointerEvents = "";
        label.style.opacity = "";
        label.style.cursor = "";
    });
    if (loader && loader.parentNode) {
      loader.parentNode.removeChild(loader);
    }
}

function employerReviewDisable() {
    // Disable all form input elements
    for (let i = 0; i < formElements.length; i++) {
        formElements[i].disabled = true;
    }
    // Disable click events and visual styling for rating labels
    ratingLabels.forEach(label => {
        label.style.pointerEvents = "none";
        label.style.opacity = "0.7";
        label.style.cursor = "default";
    });
    employerReviewSubmit.append(loader);
}
